export default __webpack_public_path__ + "f64d39be1356d1505edbadbd684a6050.woff";